export const currency = (number) => {
    let total = number / 100;
    return total.toFixed(2);
}
